<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-form label-width="80px">
                    <el-form-item label="团队介绍">
                        <el-input v-model="Property_Team" type="textarea" rows="10" placeholder="请输入内容..."></el-input>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="24">
                <el-form label-width="80px">
                    <el-form-item label="团队介绍">
                        <el-input v-model="Property_Planner" type="textarea" rows="10"
                            placeholder="请输入内容..."></el-input>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form label-width="80px">
                    <el-form-item label="答题测试">
                        <el-switch v-model="Property_NoticeSwitch" active-text="开启" inactive-text="关闭"></el-switch>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12" :offset="12">
                <el-button type="primary" @click="saveSet">保存</el-button>
            </el-col>
        </el-row>
    </div>

</template>

<script>
export default {
    data() {
        return {
            Property_Team: "",
            Property_Planner: "",
            Property_NoticeSwitch: false
        }
    },
    methods: {
        pullSet() {
            this.ipost(
                "/AdminAjax/Property.ashx?type=selectOne", null,
                (res) => {
                    console.log("res:", res);
                    this.Property_Team = res.model.Property_Team;
                    this.Property_Planner = res.model.Property_Planner;
                    this.Property_NoticeSwitch = (res.model.Property_NoticeSwitch == 0 ? false : true);
                }
            );
        },
        saveSet() {
            this.ipost(
                "/AdminAjax/Property.ashx?type=update", {
                team: this.Property_Team,
                planner: this.Property_Planner,
                noticeswitch: (this.Property_NoticeSwitch ? 1 : 0)
            },
                (res) => {
                    console.log("res:", res);
                    this.$message.success("保存成功");
                }
            );
        }

    },
    mounted() {
        this.pullSet()
    }
}
</script>

<style scoped></style>